import React from 'react';
import Flexbox from 'flexbox-react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Button, FormGroup, Intent, NumericInput } from '@blueprintjs/core';
import NumberValueValidator from '../shared/NumberValueValidator';
import Utilities from '../../utils/Utilities';
import _ from 'lodash';

@inject(
  'CurrentUserStore',
  'ToastStore',
  'AppStore',
  'ItemStore',
  'ItemActions',
  'UserProfileStore',
  'UserProfileTemplateStore',
  'TemplateActions'
)
@observer
export default class FormElementPercentage extends React.Component {
  @observable
  store = '';
  @observable
  actions = '';
  @observable
  inputValue = '';
  @observable
  actionType = 'creating';
  @observable
  newId = Utilities.makeId();

  componentDidMount() {
    this.setStoreAndActions();
    if (this.props.element.formValues.length > 0) {
      this.actionType = 'updating';
      let value = this.props.element.formValues[0].decimalValue;
      if (this.props.element.formValues[0].decimalValue % 1 === 0 && this.props.element.formValues[0].decimalValue !== '') {
        value = parseInt(this.props.element.formValues[0].decimalValue);
      }
      if (isNaN(value)) {
        value = '';
      }
      this.inputValue = _.clone(value);
    }
    this.mountDisplayValuesInFlight();
    this.props.validateInput(this.inputValue);
  }

  mountDisplayValuesInFlight() {
    _.map(this.store.formValuesToCreate, formValue => {
      if (formValue.element_id === this.props.element.id) {
        this.inputValue = formValue.decimal_value;
      }
    });
    _.map(this.props.element.formValues, formValue => {
      const findFormValueToChange = _.find(this.store.formValuesToChange, o => o.id === formValue.id);
      if (findFormValueToChange) {
        this.inputValue = findFormValueToChange.decimal_value;
      }
    });
  }

  setStoreAndActions() {
    this.newId = this.props.element.id;
    switch (this.props.storeType) {
      case 'profile':
        this.store = this.props.UserProfileTemplateStore;
        this.actions = this.props.TemplateActions;
        break;
      default:
        this.store = this.props.ItemStore;
        this.actions = this.props.ItemActions;
        break;
    }
  }

  appendAttributes(object) {
    switch (this.props.storeType) {
      case 'profile':
        object.user_id = this.props.UserProfileStore.user.id;
        object.profile_template_id = this.props.UserProfileTemplateStore.activeProfileTemplate.id;
        object.profile_value_type = 'decimal';
        return object;
      default:
        object.item_id = this.store.item.id;
        object.item_value_type = 'decimal';
        return object;
    }
  }

  handleInputChange(n, s) {
    this.inputValue = s;
    if (this.actionType === 'updating') {
      const changedFormValue = {
        id: this.props.element.formValues[0].id,
        decimal_value: this.inputValue,
      };
      this.store.addFormValueToChange(changedFormValue);
    } else {
      let newFormValue = {
        id: this.newId,
        element_id: this.props.element.id,
        decimal_value: this.inputValue,
      };
      newFormValue = this.appendAttributes(newFormValue);
      this.store.addFormValueToCreate(newFormValue);
    }
    this.props.validateInput(this.inputValue);
  }

  renderHelperText() {
    if (this.props.showError) {
      return (
        <Flexbox flexDirection="column">
          {_.map(this.props.errors, error => (
            <span key={error.errorMessage}>{error.errorMessage}</span>
          ))}
        </Flexbox>
      );
    }
    return undefined;
  }

  renderLengthValidator() {
    if (!this.store.submissionAttempted) {
      return (
        <NumberValueValidator
          value={this.inputValue}
          minValue={this.props.element.elementNumber.minValue}
          maxValue={this.props.element.elementNumber.maxValue}
          disabled={
            !this.props.element.isEditable ||
            (this.props.element.elementNumber.minValue === 0 && this.props.element.elementNumber.maxValue === 0)
          }
          prefix={this.props.element.elementNumber.prefix}
          suffix={this.props.element.elementNumber.suffix}
        />
      );
    }
    return undefined;
  }

  render() {
    return (
      <Flexbox flexDirection="column" flexGrow={1}>
        <FormGroup
          label={this.props.element.elementNumber.name}
          labelFor={this.props.element.id}
          labelInfo={this.props.element.isRequired ? `(${I18n.t('js.required')})` : ''}
          intent={this.props.showError ? Intent.DANGER : null}
          helperText={this.renderHelperText()}
        >
          <Flexbox className="bp3-control-group">
            <NumericInput
              id={this.props.element.id}
              allowNumericCharactersOnly={false}
              placeholder={this.props.element.elementNumber.placeholderText}
              disabled={!this.props.element.isEditable}
              value={this.inputValue}
              onValueChange={this.handleInputChange.bind(this)}
              intent={this.props.showError ? Intent.DANGER : null}
              buttonPosition="none"
            />
            <Button disabled={!this.props.element.isEditable} intent={this.props.showError ? Intent.DANGER : null} icon="percentage" />
          </Flexbox>
          {this.renderLengthValidator()}
        </FormGroup>
      </Flexbox>
    );
  }
}
